import { CloudCommand } from "../types.js";

export const getViewersCount: CloudCommand = {
    action: "USER_INFOS/GET_VIEWERS_COUNT",
    commandName: "linkedin.user.getViewersCount",
    buildPayload: () => ({}),
};
